import { db } from "@modules/local/db";
import * as Api from "../../../modules/api";
import { useAppLiveQuery } from "@modules/local/hooks";

export function useContentEntityLiveQuery(uniqueId: string, limit?: number) {
  return useAppLiveQuery<
    | { id: string; data: Api.Server.ContentEntityOutput[] | undefined }
    | undefined
  >(async () => {
    const uiInfo = await db.uiEntities.get(uniqueId);
    const contentIds = uiInfo?.contentIds;
    const limitedContentIds = limit ? contentIds?.slice(0, limit) : contentIds;

    if (!limitedContentIds) return undefined;

    const data = (await db.entities.bulkGet(
      limitedContentIds
    )) as Api.Server.ContentEntityOutput[];

    return {
      id: uniqueId,
      data: uniqueId === uiInfo?.uniqueId ? data : undefined,
    };
  }, [uniqueId, limit]);

  // return useAppSelector(
  //   (state) =>
  //     state.content.linkedData[uniqueId]?.contents?.slice(0, limit ?? 10000) ??
  //     [],
  //   (prev, next) => {
  //     if (prev === next) return true;
  //     if (prev.length !== next.length) return false;
  //     for (let i = 0; i < prev.length; i++) {
  //       if (!compareContent(prev[i], next[i])) return false;
  //     }
  //     return true;
  //   }
  // );
}
